// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/adjustments",
  Create: "/pyr/adjustments",
};
